export const CATEGORIES = ['所有类型', 'meetup', '开发者活动/竞赛'];
export const TYPES = ['线上/线下', '线上', '线下'];
export const DATES = ['所有时间', '2021', '2020', '2019', '更早'];
export const LOCATIONS = ['全球', '北京', '上海', '杭州', '深圳', '广州', '成都', '其他'];
